import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  li {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomSelectMenuItem, CustomTextField } from "@/components/Categories/Menu";
import { CategoryProductListView } from "@/components/Categories/Menu/CategoryProductListView";
import SelectedFilterWrapper from "@/components/Categories/Menu/SelectedFilter";
import { FilterQueryHandlerType, useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { useMobileFilterSideSheet } from "@/hooks/useMobileFilterSideSheet";
import { usePagination } from "@/hooks/usePaginationNew";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Pagination } from "@bookips/solvook-ui-library";
import { Box, Typography, styled, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getBrandCategoryId } from "src/api/brand";
import { CategoryQueryKey } from "src/api/category";
import { SearchQueryKey } from "src/api/search";
import Icon from "../../../icon/Icon";
import { ArrowDown, Sizes } from "../../../icon/IconList";
import { useBrandStore } from "../../BrandProvider";
import BrandFilter from "../BrandFilter";
import { PrevButton } from "../PrevButton";
import { routerOptions } from "../Search/useSearchBarHandler";
import useSearchParamHandler from "../useSearchParamHandler";
import { DEFAULT_EMOJI } from "./BrandCategory";
import { BrandCategoryDrawer } from "./BrandCategoryDrawer";
import BrandCategoryFilter from "./BrandCategoryFilter";
export const DEFAULT_LIMIT = 24;
const DetailCategoryProducts = ()=>{
    var _categoryItems_sortItems, _categoryItems_sortItems1;
    const router = useRouter();
    const theme = useTheme();
    const name = useBrandStore((state)=>state.brand.name);
    const [isSideSheetOpen, setIsSideSheetOpen] = useState(false);
    const { filterQueryHandler , searchParams  } = useCategoryFilterHandler({
        isUseAsPath: true,
        routerOptions: routerOptions
    });
    const { mobileFilterSideSheet , handleMobileSideSheet  } = useMobileFilterSideSheet();
    const { addLabelSelectedTicket  } = useSearchParamHandler();
    const onCloseClick = useCallback(()=>{
        return setIsSideSheetOpen(false);
    }, []);
    const categoryId = useMemo(()=>{
        return searchParams.get(CategoryQueryKey.CATEGORY);
    }, [
        searchParams
    ]);
    const { data: categoryItems , isLoading  } = useQuery([
        "brandCategoryItem",
        searchParams.toString(),
        name
    ], ()=>getBrandCategoryId({
            name: name,
            sort: searchParams.get(CategoryQueryKey.SORT),
            categoryId: categoryId,
            "authors[]": searchParams.getAll(SearchQueryKey.AUTHORS),
            "dataTypes[]": searchParams.getAll(SearchQueryKey.DATATYPES),
            "units[]": searchParams.getAll(SearchQueryKey.UNITS),
            "relatedBooks[]": searchParams.getAll(SearchQueryKey.RELATEDBOOKS),
            "tickets[]": searchParams.getAll(SearchQueryKey.TICKETS),
            offset: offset,
            limit: DEFAULT_LIMIT
        }), {
        enabled: !!categoryId,
        keepPreviousData: true
    });
    var _categoryItems_count;
    const { offset , onChangePage , ...paginationProps } = usePagination({
        limit: DEFAULT_LIMIT,
        totalCount: (_categoryItems_count = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.count) !== null && _categoryItems_count !== void 0 ? _categoryItems_count : 0,
        isUseAsPath: true
    });
    //  id가 없을경우 이전 페이지로 이동
    useEffect(()=>{
        if (!categoryId) {
            router.back();
        }
    }, [
        categoryId,
        router
    ]);
    var _categoryItems_emoji, _categoryItems_totalCount, _addLabelSelectedTicket, _addLabelSelectedTicket1, _categoryItems_count1, _categoryItems_selectedSort, _categoryItems_filterItems;
    return /*#__PURE__*/ _jsxs(LayoutBox, {
        children: [
            /*#__PURE__*/ _jsxs(MainContentBox, {
                children: [
                    /*#__PURE__*/ _jsx(PrevButton, {}),
                    /*#__PURE__*/ _jsxs(SelectedCategory, {
                        role: "button",
                        onClick: ()=>{
                            setIsSideSheetOpen(true);
                            //mx-193
                            mixpanelEvent("Banner UI Clicked", {
                                Position: "Brand Category Page",
                                "Banner Name": categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.title,
                                "Brand Name": name
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "body1",
                                sx: {},
                                children: [
                                    "".concat((_categoryItems_emoji = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.emoji) !== null && _categoryItems_emoji !== void 0 ? _categoryItems_emoji : DEFAULT_EMOJI, " ").concat((categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.title) || "", " "),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body1",
                                        component: "span",
                                        sx: {
                                            color: theme.palette.text.disabled
                                        },
                                        children: (_categoryItems_totalCount = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.totalCount) !== null && _categoryItems_totalCount !== void 0 ? _categoryItems_totalCount : (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.count) || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: ArrowDown,
                                color: theme.palette.grey[300],
                                size: Sizes.small
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(BrandFilter, {
                filterItems: categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.filterItems,
                handleMobileSideSheet: handleMobileSideSheet
            }),
            ((_addLabelSelectedTicket = addLabelSelectedTicket(categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.filterItems)) !== null && _addLabelSelectedTicket !== void 0 ? _addLabelSelectedTicket : []).length > 0 && /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
                className: "category",
                position: undefined,
                button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
                    handleResetFilter: ()=>{
                        filterQueryHandler({
                            filterType: FilterQueryHandlerType.RESET
                        });
                    }
                }),
                children: ((_addLabelSelectedTicket1 = addLabelSelectedTicket(categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.filterItems)) !== null && _addLabelSelectedTicket1 !== void 0 ? _addLabelSelectedTicket1 : []).map((item, idx)=>{
                    return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                        className: "category current-btn",
                        label: item.label,
                        onRemove: ()=>filterQueryHandler({
                                filterType: FilterQueryHandlerType.DETAILFILTER,
                                filterName: item.key,
                                value: item.value
                            })
                    }, "selectedItem" + idx);
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    padding: "20px 0 12px 0",
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        sx: {
                            color: theme.palette.text.secondary
                        },
                        children: "총 ".concat((_categoryItems_count1 = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.count) !== null && _categoryItems_count1 !== void 0 ? _categoryItems_count1 : 0, "건")
                    }),
                    (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.count) > 0 && categoryItems.selectedSort && /*#__PURE__*/ _jsx(CustomTextField, {
                        select: true,
                        value: (_categoryItems_selectedSort = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.selectedSort) !== null && _categoryItems_selectedSort !== void 0 ? _categoryItems_selectedSort : categoryItems === null || categoryItems === void 0 ? void 0 : (_categoryItems_sortItems = categoryItems.sortItems) === null || _categoryItems_sortItems === void 0 ? void 0 : _categoryItems_sortItems[0],
                        onChange: (e)=>{
                            filterQueryHandler({
                                filterType: FilterQueryHandlerType.SORT,
                                value: e.target.value
                            });
                        },
                        children: categoryItems === null || categoryItems === void 0 ? void 0 : (_categoryItems_sortItems1 = categoryItems.sortItems) === null || _categoryItems_sortItems1 === void 0 ? void 0 : _categoryItems_sortItems1.map((option)=>{
                            return /*#__PURE__*/ _jsx(CustomSelectMenuItem, {
                                value: option,
                                className: "select",
                                children: option
                            }, option);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CategoryProductListView, {
                isLoadingListItem: isLoading,
                items: categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.items,
                limit: DEFAULT_LIMIT
            }),
            paginationProps.totalPage > 0 && /*#__PURE__*/ _jsx(Pagination, {
                page: paginationProps.currentPage,
                onChange: (event, page)=>onChangePage(page),
                count: paginationProps.totalPage,
                size: "medium",
                sx: {
                    "& ul": {
                        justifyContent: "center",
                        margin: "32px 0 20px 0"
                    }
                }
            }),
            categoryItems && /*#__PURE__*/ _jsx(BrandCategoryFilter, {
                open: mobileFilterSideSheet,
                openFilter: handleMobileSideSheet,
                filterItems: (_categoryItems_filterItems = categoryItems.filterItems) !== null && _categoryItems_filterItems !== void 0 ? _categoryItems_filterItems : []
            }),
            /*#__PURE__*/ _jsx(BrandCategoryDrawer, {
                open: isSideSheetOpen,
                handleClose: onCloseClick
            })
        ]
    });
};
const LayoutBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        [theme.breakpoints.down("lg")]: {
            margin: "32px"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "28px 20px"
        }
    };
});
const MainContentBox = styled("section")((theme)=>({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px"
    }));
export const SelectedCategory = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        maxWidth: "824px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: theme.palette.grey[0],
        padding: "12px 16px",
        borderRadius: "8px",
        ":hover": {
            cursor: "pointer",
            backgroundColor: "rgba(169, 175, 199, 0.20)"
        }
    };
});
export const CategoryFilterBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        // width: '100%',
        display: "flex",
        gap: "8px",
        margin: "16px 0",
        overflowX: "auto",
        button: {
            flexShrink: 0
        }
    };
});
const SearchLastDropdownStyle = styled("div")(_templateObject());
export default DetailCategoryProducts;
